module.exports = __webpack_public_path__ + "static/media/optum.d5601846.svg";